import { Arbeitsbereich } from '@/domain/mitarbeiter/features/rotationsplan/features/Plaene/desktop/components/Arbeitsbereich';
import { Mitarbeiter } from '@/domain/mitarbeiter/features/rotationsplan/features/Plaene/desktop/components/Mitarbeiter';
import { Qualifikationen } from '@/domain/mitarbeiter/features/rotationsplan/features/Plaene/desktop/components/Qualifikationen';
import { Rotationsplan } from '@/domain/mitarbeiter/features/rotationsplan/features/Plaene/entities/Rotationsplan';
import { ArbeitsbereichStation } from '@/domain/mitarbeiter/features/rotationsplan/features/Plaene/entities/Station';

export function RotationsplanCard({
  rotationsplan,
}: {
  rotationsplan: Rotationsplan;
}) {
  const currentStation = rotationsplan.getCurrentStation();
  const nextStation = rotationsplan.getNextStation();

  return (
    <div className="w-full h-49 bg-white rounded-md p-4 flex flex-col gap-4">
      <Mitarbeiter rotationsplan={rotationsplan} />
      {currentStation && currentStation instanceof ArbeitsbereichStation && (
        <Arbeitsbereich arbeitsbereichStation={currentStation} />
      )}
      {!currentStation &&
        nextStation &&
        nextStation instanceof ArbeitsbereichStation && (
          <Arbeitsbereich arbeitsbereichStation={nextStation} isNext />
        )}
      <Qualifikationen rotationsplan={rotationsplan} />
    </div>
  );
}
